import React from 'react';

export default class TextAreaInput extends React.Component {
   static defaultProps = {
        value : undefined,
        onChange: () => {}
    };

    constructor(props) {
    	super(props);
        
        this.state = {
            placeholder: props.placeholder,
            initialValue: props.initialValue,
        }
  	}

    handleOnChange(event) {
        this.props.onChange(event.target.value);
    }

    focus() {
        this.textArea.focus();
    }

    render() {
        var { placeholder, rows, autoFocus } = this.props;
        
        return (
    		<div>
                <textarea 
                    ref={el => this.textArea = el}
                    style={this.props.style} 
                    value={this.props.value} 
                    defaultValue={this.state.initialValue} 
                    className="b3-input b3-textarea" 
                    onChange={this.handleOnChange.bind(this)} 
                    onFocus={this.props.onFocus} 
                    onBlur={this.props.onBlur} 
                    placeholder={placeholder} 
                    autoFocus={autoFocus}
                    rows={rows}></textarea>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/b3/inputs/TextAreaInput.js